#import "@/apollo/fragments/Job.gql"

query MyJobsByStatus($status: [JobStatus]) {
    myJobsByStatus(status: $status) {
        ...Job
    }
}
